/**
 * @generated SignedSource<<500dafb052d665efa71a17643ba2d271>>
 * @relayHash d7ad70c9bbd7f02a1d4a4f712848438c
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d7ad70c9bbd7f02a1d4a4f712848438c

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type FinalizeItemInput = {
  clientMutationId?: string | null;
  id: string;
  scope?: string | null;
};
export type examsFinalizeItemMutation$variables = {
  input: FinalizeItemInput;
};
export type examsFinalizeItemMutation$data = {
  readonly finalizeItem: {
    readonly exam: {
      readonly registrations: ReadonlyArray<{
        readonly final: boolean;
        readonly id: string;
      }>;
    } | null;
  } | null;
};
export type examsFinalizeItemMutation = {
  response: examsFinalizeItemMutation$data;
  variables: examsFinalizeItemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Registration",
  "kind": "LinkedField",
  "name": "registrations",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "final",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "examsFinalizeItemMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FinalizeItemPayload",
        "kind": "LinkedField",
        "name": "finalizeItem",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Exam",
            "kind": "LinkedField",
            "name": "exam",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "examsFinalizeItemMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FinalizeItemPayload",
        "kind": "LinkedField",
        "name": "finalizeItem",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Exam",
            "kind": "LinkedField",
            "name": "exam",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "d7ad70c9bbd7f02a1d4a4f712848438c",
    "metadata": {},
    "name": "examsFinalizeItemMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "de2e1b8b803fc6608203c948d489246d";

export default node;
